﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import { NotificationType, sendNotification } from '@tk/utilities/tk.notification';

interface PostFieldResponse {
    success: boolean;
    message: string;
}

export default class KWAsyncPostField extends TKCustomElementFactory {
    action?: string;
    submitButton?: HTMLButtonElement;
    fieldElement?: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
    timer?: ReturnType<typeof setTimeout>;

    constructor() {
        super();

        this.action = this.getAttribute('data-tk-action') || undefined;
        this.submitButton = this.querySelector('button[type="submit"]') || undefined;
        this.fieldElement = this.querySelector('input, select, textarea') || undefined;
    }

    connectedCallback(): void {
        if (!this.action || !this.fieldElement) throw new Error('Async Post Field: Elements are missing!');
        this.submitButton
            ? this.registerSubmitListener()
            : this.registerInputListener();
    }

    registerInputListener() {
        this.pushListener({
            event: 'input',
            element: this.fieldElement!,
            action: this.handleInput.bind(this),
        });
    }

    registerSubmitListener() {
        this.pushListener({
            event: 'click',
            element: this.submitButton!,
            action: this.post.bind(this),
        });
    }

    handleInput() {
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.post();
        }, 500);
    }

    post() {
        const { value } = this.fieldElement!;
        const payload = {
            value,
        };

        fetchRequest({
            requestURL: this.action!,
            payload,
            resolveHandler: KWAsyncPostField.handleResponse.bind(this),
        });
    }

    static handleResponse(response: TKResponse<PostFieldResponse>) {
        if (!response || !response.success) return;
        const { success, message } = response.dataAsJson;
        if (!success || !message) return;
        sendNotification(NotificationType.SUCCESS, message);
    }
}